<template>
  <ks-data-form
      class="d-flex flex-row align-items-center"
      :style="`width:${screenSizeId >= 4 ? defaultSearchWidth : ''}`"
      formType="filter"
      :dataProvider="cDataProvider"
      :submitOnChange="false"
  >
    <ks-data-form-body
        class="input-group d-flex flex-row align-items-center"
        v-slot="{record, index}"
    >
      <ks-data-mode-selector
          ref="search_data_mode"
          :data-provider="dataProvider"
          :enable-actions="enableSelectorModesActions"
          :showButtons="true"
          :showMenu="false"
          :buttonDropdown="false"
          :facetCounts="facetCounts"
          :style="flexGrow ?  'flex-grow: 3' : ''"
          v-if="leftQuickIcons"
      />
      <div
          v-if="showSelectorModes"
          :class="screenSizeId >= 4 ? 'input-group-prepend' : ''"
      >
        <div
            class="dropdown"
            :style="screenSizeId >= 4 ? '' : show_search_field ? 'display: none' : 'display: block;'"
        >
          <ks-data-mode-selector
              ref="search_data_mode"
              :data-provider="dataProvider"
              :enable-actions="enableSelectorModesActions"
              :showButtons="false"
              :button-dropdown="true"
              :style="flexGrow ?  'flex-grow: 3' : ''"
          />
        </div>
      </div>
      <input
          id="search-field"
          v-model="l_search_string"
          class="form-control"
          :style="screenSizeId >= 4 ? '' : show_search_field ? 'display: block; width: 40%;' : 'display: none'"
          type="text"
          @keypress="onKeyPress"
          @keypress.enter.prevent="search(0)"
          :placeholder="`Search...`"
      />
      <div
          v-if="showSearchButton"
          class="input-group-append"
          id="search-button"
      >
        <button
            :class="screenSizeId >= 4 ? 'btn btn-outline-secondary' : 'btn btn-link p-1 m-1'"
            type="button"
            @click.prevent="search(0)"
        >
          <ks-icon
              icon="search"
          />
        </button>
      </div>
      <span
          v-if="record.search_string || l_search_string && showClearButton"
          @click.prevent="clearSearch()"
          class="ml-2"
      >
        <i
            class="far fa-times-circle mb-0 text-danger"
            style="color: darkred; cursor: pointer; font-size: 1.125rem;"
        />
      </span>
      <ks-data-mode-selector
          ref="search_data_mode"
          :data-provider="dataProvider"
          :enable-actions="enableSelectorModesActions"
          :showButtons="true"
          :showMenu="false"
          :buttonDropdown="false"
          :facetCounts="facetCounts"
          :style="flexGrow ?  'flex-grow: 3' : ''"
          v-if="!leftQuickIcons"
      />
    </ks-data-form-body>
  </ks-data-form>
</template>

<script>
import onMountedDataProvider from '../../mixins/onMountedDataProvider';

export default {
  name:     'ks-search',
  mixins:   [onMountedDataProvider],
  props:    {
    leftQuickIcons:             {type: Boolean, default: true},
    flexGrow:                   {type: Boolean, default: true},
    showSearchButton:           {type: Boolean, default: true},
    showClearButton:            {type: Boolean, default: true},
    showSelectorModes:          {type: Boolean, default: true},
    enableSelectorModesActions: {type: Boolean, default: false},
    submitOnChange:             {type: Boolean, default: false},
    defaultSearchWidth:         {type: String, default: "100%"},
    searchPlaceholder:          {type: String, default: 'Search...'},
    dataProvider:               {type: String, default: null},
    inputStyles:                {type: String, default: ''}, //'flex-grow: 1'
    searchMode:                 {type: String, default: null},
    searchModeId:               {type: Number, default: null},
    facetCounts:                {
      type: Array, default: () => {
        return [
          {
            'data_mode_name': null,
            'facet_name':     null,
            'facet_count':    null,
          }
        ]
      }
    }
  },
  computed: {
    cDataProvider() {
      return this.dataProvider ? this.dataProvider : (this.$parent.dataProvider ? this.$parent.dataProvider : null);
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    /*l_search_string: {
      get: () => {
        return app.store.state.ks_app.global_data.l_search_string;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setLocalSearchString', value);
      }
    }*/
  },
  methods:  {
    search(time) {
      this.show_search_field = !(this.screenSizeId < 3 && this.show_search_field);
      let data_provider      = app.getDataprovider(this.dataProvider);
      if (this.searchMode) {
        data_provider.selectModeByName(this.searchMode, false);
      }
      if (this.searchModeId) {
        data_provider.selectModeById(this.searchModeId, false);
      }
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        await data_provider.updateFilters({
          'search_string': this.l_search_string
        }, true);
        // if (this.screenSizeId < 3) this.show_search_field = false;
        this.$emit('search', this.l_search_string);
      }, time * 1000);
    },
    clearSearch() {
      if (!this.preventDefaultClearSearch) {
        this.l_search_string = '';
        let data_provider    = app.getDataprovider(this.dataProvider);

        data_provider.selectDefaultMode();

        data_provider.updateFilters({
          'search_string': this.l_search_string
        }, true);
        this.$emit('clearSearch', this);
      }
      this.show_search_field = false;
    },
    onKeyPress() {
      if (this.submitOnChange) {
        this.search(2);
      }
      this.$emit('onKeyPress', this);
    },
  },
  data() {
    return {
      timer:             null,
      l_search_string:   null,
      show_search_field: false
    }
  },
  mounted() {
    let _this = this;
    window.addEventListener('click', function (e) {
      if (
          document.getElementById('search-field')?.contains(e.target) ||
          document.getElementById('search-button')?.contains(e.target)
      ) {
      } else {
        _this.show_search_field = false;
      }
    });

  }
}
</script>
<style scoped>

</style>
